import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/file.svg';
const File = () => React.createElement(IconSvg, null);
export default File;
